// Used in create-expert and customer satisfaction forms
function nfyCtrl($window, $location, $element, $scope) {
  const { dataLayer } = $window;
  const vm = this;

  vm.formInputs = {};
  vm.formView = false;
  vm.thankYouView = false;
  vm.config = {
    actionUrl: `${$location.href.replace(/\/$/, '')}#thankyou`,
    hashStr: $location.hash,
    formName: $element.find('form').attr('id'),
    triedSubmit: false
  };

  vm.nfyCheckHash = () => {
    $element.find('.thankYouView').css('visibility', 'visible');

    if (vm.config.hashStr === '#thankyou') {
      vm.thankYouView = true;
    } else {
      vm.formView = true;
    }
  };

  vm.nfySubmit = (formValid) => {
    if (formValid) {
      dataLayer.push({
        event: 'formSubmit',
        formName: vm.config.formName
      });

      $element.find('form').attr('action', vm.config.actionUrl);

      setTimeout(() => {
        $element.find('form').submit();
      }, 1000);
    } else {
      vm.config.triedSubmit = true;
    }
  };

  vm.nfyCheckHash();

  //adding ability to step through mutliple pages/steps
  //with validation on each page
  vm.step = 1;

  vm.nextStep = () => {
    const currStep = vm.step;
    const formName = `scene_${currStep}`;
    const ngForm = $scope[formName];

    if (vm.isFormValid($scope, ngForm)) {
      vm.step++;
      const thisForm = $(`.scene-${vm.step}`);
      const mainForm = $(thisForm).closest('form').closest('form');

      $('html,body').animate({
        scrollTop: $(mainForm).offset().top - 100
      }, 500);
    } else {
      const invalidFields = $(`.scene-${currStep} .ng-invalid`);
      const firstInvalidField = invalidFields[0];

      $('html,body').animate({
        scrollTop: $(firstInvalidField).offset().top - 100
      }, 500);
    }
  };

  vm.prevStep = () => {
    vm.step--;
  };

  vm.stepTo = (stepNo) => {
    vm.step = stepNo;
  };

  /** manually triggers $validate event to validate the given form */
  vm.isFormValid = (ngForm) => {
    $scope.$broadcast('$validate');

    if (ngForm.$invalid) {
      // make the form fields '$dirty' so that the validation messages would be shown
      ngForm.$dirty = true;

      ngForm.forEach((field) => {
        if (field && field.hasOwnProperty && field.hasOwnProperty('$dirty')) {
          field.$setDirty();
        }
      });
    } else {
      //if form is valid, allow click
      return true;
    }
  };

  vm.resetFormElement = (e) => {
    e.wrap('<form>').closest('form').get(0).reset();
    e.unwrap();

    // Prevent form submission
    e.stopPropagation();
    e.preventDefault();
  };
}

nfyCtrl.$inject = ['$window', '$location', '$element', '$scope'];

export default nfyCtrl;
